import { render } from "./ServiceRequestStatusPage.vue?vue&type=template&id=ff6393f4"
import script from "./ServiceRequestStatusPage.vue?vue&type=script&lang=js"
export * from "./ServiceRequestStatusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__